import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    addFundsFromShineAccount: 'Credit from a wallet',
    noTransaction: 'You have no transactions on this wallet yet.',
    shareMyIban: 'Share my IBAN',
  },
  fr: {
    addFundsFromShineAccount: 'Créditer depuis un compte Shine',
    noTransaction:
      'Vous n’avez aucune transaction sur ce compte pour le moment.',
    shareMyIban: 'Partager mon IBAN',
  },
} as const);

export default locales;
